module.exports = __webpack_public_path__ + "static/media/home_page_wittledefender_background_m@2x.e8b307f0.png";